/**
 * 多图/多媒体路径字符串解析（全局 showImage）。
 * 支持 , ; | 中文分隔符及 %2C %3B URL 编码、多 https 粘连。
 * 最后更新：2026-07-01
 */
import { parseMediaFilesList } from '../utils/mediaUrl'

export default {
  methods: {
    showImage(data) {
      return parseMediaFilesList(data)
    },
  },
}
